// Fallback used until the backend's /song/playlist-url response reaches Redux.
// Must match the station's `listen_url` in AzuraCast. Icecast is not reachable
// on port 8000 from outside; it is only exposed through the proxy on 443.
export const RADIO_STREAM_URL =
  process.env.REACT_APP_RADIO_STREAM_URL ||
  'https://azuracast.cfader.com/listen/cfader/radio.mp3';
